import { useNamedStore } from "@/lib/zustand/useNamedStore";
import { KeyOption } from "@/types/defs/keyOption";

type State = {
  key: KeyOption;
  setKey: (key: KeyOption) => void;
};

const useKeyInput = (
  set: (
    partial:
      | State
      | Partial<State>
      | ((state: State) => State | Partial<State>),
    replace?: boolean
  ) => void
): State => ({
  key: "No Key",
  setKey: (key: KeyOption) => set({ key }),
});

export const useNamedKey = useNamedStore(() => useKeyInput);
